module.exports = __webpack_public_path__ + "media/services/smart-invest-1c1ae631.svg";